$( document ).ready(function() {
  if ($(window).width() < 555) {
    $('.custom-column-1').css('width', '100%');
    $('.custom-column-2').css('width', '100%');
  }
  if ($(window).width() > 555) {
    $('.custom-column-1').css('width', '60%');
    $('.custom-column-2').css('width', '40%');
  }
});

$(document).ready(function(){
    // Loop through each div to find patch/hem fields
  setTimeout(
  function() 
  {

    $(".w3-product-options").each(function(){
        // Test if the div element is empty
        if($(this).is(":empty")){
            
        } else {
         $( ".description" ).prepend( "<p><i>*please allow 1 week if adding a custom patch or hem</i></p>" );
          }
    });
  }, 2000);
});


    
   $(".swatch").click(function(){ 
      $("#bissuccess").css("display","none");
      $("#bisform").css("display","block");
      $("#biscontainer").css("border","1px solid red");
    
});   
    
$(document).ready(function () {    
  $("#bissubmit").click(function (event) {

const settings = {
  async: true,
  crossDomain: true,
  url: 'https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=Stfw3G',
  method: 'POST',
  headers: {
    accept: 'application/vnd.api+json',
    revision: '2024-10-15',
    'content-type': 'application/vnd.api+json'
  },
  data: '{"data":{"type":"back-in-stock-subscription","attributes":{"profile":{"data":{"type":"profile","attributes":{"email":"'+$("#bisemail").val()+'"}}},"channels":["EMAIL"]},"relationships":{"variant":{"data":{"type":"catalog-variant","id":"$shopify:::$default:::'+$(".multi_select").val()+'"}}}}}'
};

$.ajax(settings).done(function (response) {
  console.log(response);
  $("#bissuccess").css("display","block");
      $("#bisform").css("display","none");
      $("#biscontainer").css("border","1px solid gray");
});


    event.preventDefault();
  });    
 });   


$(document).ready(function () {
$('.faceted-filter-group-display__list-item-label-text').each(function() {
    // get element text
    var text = $(this).text();
    // modify text
    text = text.replace('Akwa ', 'AAC ');
    // update element text
    $(this).text(text); 
});
$('.faceted-filter-group-display__list-item-label-text').each(function() {
    // get element text
    var text = $(this).text();
    // modify text
    text = text.replace('All American Khaki ', 'All American Twill Pants ');
    // update element text
    $(this).text(text); 
});
$('.faceted-filter-group-display__list-item-label-text').each(function() {
    // get element text
    var text = $(this).text();
    // modify text

    // update element text
  if (text=='ShopWill (1)'){
    $(this).hide(); };
});   
$('.faceted-filter-group-display__list-item-input').each(function() {
    // get element text
    var text = $(this).val();
    var id = $(this).attr('id');
    // modify text

    // update element text
  if (text=='ShopWill'){
    $(this).hide(); 
    $('#'+id+', label[for="'+id+'"]').hide();
   };
});
 

  
});

$(document).ready(function() {
    // Get the full URL of the current page
    var currentUrl = window.location.href;

    // Iterate through each anchor tag (link) within a specific menu or container
    // Adjust the selector '#yourMenuId a' to target your specific navigation links
    $('.jean-nav a').each(function() {
        // Get the absolute href of the current link
        var linkHref = this.href;

        // Compare the link's href with the current page's URL
        if (linkHref === currentUrl) {
            // If they match, add the 'active' class to the link
            $(this).addClass('active-jean-nav');
        }
    });
});

